import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../ui/Table';
import type { TuningRecommendation } from '../../services/tuning';

interface RecommendationsPanelProps {
  recommendations: TuningRecommendation[];
}

const PRIORITY_VARIANTS: Record<string, 'red' | 'yellow' | 'green'> = {
  high: 'red',
  medium: 'yellow',
  low: 'green',
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function RecommendationsPanel({ recommendations }: RecommendationsPanelProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">
          Pending Recommendations ({recommendations.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {recommendations.length === 0 ? (
          <p className="text-sm text-text-secondary py-6 text-center">
            No pending tuning recommendations for this tenant.
          </p>
        ) : (
          <>
            <p className="text-xs text-text-secondary mb-3">
              Recommendations are reviewed and applied by operators in the Operations Portal.
            </p>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Title</TableHead>
                  <TableHead>Category</TableHead>
                  <TableHead>Source</TableHead>
                  <TableHead>Priority</TableHead>
                  <TableHead>Created</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {recommendations.map((r) => (
                  <TableRow key={r.recommendationId}>
                    <TableCell>
                      <div className="text-sm text-text-primary">{r.title}</div>
                      <div className="text-xs text-text-secondary mt-0.5 line-clamp-2">
                        {r.description}
                      </div>
                    </TableCell>
                    <TableCell>
                      <span className="text-xs text-text-secondary">{r.category}</span>
                    </TableCell>
                    <TableCell>
                      <span className="text-xs text-text-secondary">{r.sourceType}</span>
                    </TableCell>
                    <TableCell>
                      <Badge variant={PRIORITY_VARIANTS[r.priority] ?? 'gray'}>
                        {r.priority}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-xs text-text-secondary">
                      {formatDate(r.createdAt)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </CardContent>
    </Card>
  );
}
